import React from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "~/stores";
import {AdvancedBarChart} from "~/components/visualization/bar-chart/AdvancedBarChart";
import {Box, Stack, Typography} from "@mui/material";
import {ChartCard} from "./ChartCard";
import {SPEND_BAR_COLOR, SPEND_TAIL} from "./chartHelpers";

/** Bars only; the donut card next to it takes the height of this card */
const SUPPLIER_SPEND_CHART_HEIGHT = 300;

/**
 * Bar per supplier (or parent supplier), largest first. Click selects one; ctrl-click excludes one.
 */
export const SupplierSpendCard: React.FC<{toggle?: React.ReactNode}> = observer(({toggle}) => {
    const {p, bagStore} = useStores();
    const manager = bagStore.advanced;
    const byParent = manager.groupParentSuppliersFilter;
    const unit = byParent ? (p.p.parentSupplierAltName?.toLowerCase() ?? 'parent supplier') : 'supplier';
    return <ChartCard
        title="Supplier spend"
        subtitle={`Total spend distribution per ${unit}`}
        actions={toggle}
        className="spend-landscape-supplier-spend">
        <AdvancedBarChart
            dataWrapper={manager.spendConcentrationData}
            loading={manager.advancedSpendConcentrationDataRM.busy}
            selection={byParent ? manager.filters.sp_ids : manager.filters.s_ids}
            onSelectionChange={byParent ? manager.parentSupplierFilterChanged : manager.supplierFilterChanged}
            chartHeight={SUPPLIER_SPEND_CHART_HEIGHT}
            barColor={SPEND_BAR_COLOR}
            tailColor={SPEND_TAIL}
        />
        <Stack direction="row" gap={2} className="spend-landscape-legend" sx={{mt: 0, pt: 1}}>
            <Stack direction="row" alignItems="center" gap={0.75}>
                <Box className="spend-landscape-legend-swatch" sx={{background: SPEND_BAR_COLOR}}/>
                <Typography variant="body2">First 80% of spend</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" gap={0.75}>
                <Box className="spend-landscape-legend-swatch" sx={{background: SPEND_TAIL}}/>
                <Typography variant="body2">Long tail</Typography>
            </Stack>
        </Stack>
    </ChartCard>;
});
